import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { provideStates } from '@ngxs/store';
import { BasicModule } from '@shared/modules/basic.module';
import { HelpArticleComponent } from '@shared/modules/help-center/components/help-article/help-article.component';
import { HelpGuideComponent } from '@shared/modules/help-center/components/help-guide/help-guide.component';
import { HelpIcon } from '@shared/modules/help-center/components/help-icon/help-icon.component';
import { HelpLink } from '@shared/modules/help-center/components/help-link/help-link.component';
import { HelpCenterSidenav } from '@shared/modules/help-center/components/help-sidenav/help-sidenav.component';
import { HelpCenterState } from '@shared/modules/help-center/state/help-center.state';
import { LindaModule } from '@shared/modules/linda.module';
import { SidenavModule } from '@shared/modules/sidenav/sidenav.module';
import { QuillEditorComponent } from 'ngx-quill';
import {
  HelpTooltipComponent,
  HelpTooltipDirective,
} from '@shared/modules/help-center/components/help-tooltip/help-tooltip.component';
import { SafeHtml } from '@shared/pipes/safe-html.pipe';

@NgModule({
  imports: [
    FormsModule,
    CommonModule,

    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatTooltipModule,
    MatDividerModule,
    MatButtonToggleModule,
    MatMenuModule,
    MatIconModule,

    BasicModule,
    LindaModule,
    SidenavModule,
    QuillEditorComponent,
    SafeHtml,
  ],
  declarations: [
    HelpIcon,
    HelpLink,
    HelpTooltipDirective,
    HelpCenterSidenav,
    HelpTooltipComponent,
    HelpArticleComponent,
    HelpGuideComponent,
  ],
  exports: [HelpIcon, HelpLink, HelpCenterSidenav, HelpGuideComponent],
  providers: [provideStates([HelpCenterState])],
})
export class HelpCenterModule {}
